import { render, staticRenderFns } from "./InvitationsAdd.vue?vue&type=template&id=19c703a2&lang=pug"
import script from "./InvitationsAdd.vue?vue&type=script&lang=js"
export * from "./InvitationsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports